/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { OpenErpServiceApi } from './services/custom/OpenErpService';
import { OpenErpUserApi } from './services/custom/OpenErpUser';
import { RoleApi } from './services/custom/Role';
import { PartnerApi } from './services/custom/Partner';
import { PartnerAddressApi } from './services/custom/PartnerAddress';
import { PartnerContactApi } from './services/custom/PartnerContact';
import { ProductApi } from './services/custom/Product';
import { ProductCategoryApi } from './services/custom/ProductCategory';
import { ProductCategoryTypeApi } from './services/custom/ProductCategoryType';
import { ProductUomApi } from './services/custom/ProductUom';
import { ProductUomCategoryApi } from './services/custom/ProductUomCategory';
import { PurchaseOrderApi } from './services/custom/PurchaseOrder';
import { PurchaseOrderLineApi } from './services/custom/PurchaseOrderLine';
import { PurchaseRequisitionApi } from './services/custom/PurchaseRequisition';
import { PurchaseRequisitionLineApi } from './services/custom/PurchaseRequisitionLine';
import { CrmClaimApi } from './services/custom/CrmClaim';
import { CrmCaseStageApi } from './services/custom/CrmCaseStage';
import { CompanyApi } from './services/custom/Company';
import { StockPickingApi } from './services/custom/StockPicking';
import { StockQuantPackageApi } from './services/custom/StockQuantPackage';
import { MoveQualityControlApi } from './services/custom/MoveQualityControl';
import { QualityMeasureValueApi } from './services/custom/QualityMeasureValue';
import { QualityMeasureApi } from './services/custom/QualityMeasure';
import { StockMoveApi } from './services/custom/StockMove';
import { StockPickingLineApi } from './services/custom/StockPickingLine';
import { StockLocationApi } from './services/custom/StockLocation';
import { StockWarehouseLocationApi } from './services/custom/StockWarehouseLocation';
import { StockWarehouseApi } from './services/custom/StockWarehouse';
import { DeliveryCarrierApi } from './services/custom/DeliveryCarrier';
import { ClaimLineApi } from './services/custom/ClaimLine';
import { UsersApi } from './services/custom/Users';
import { GroupsApi } from './services/custom/Groups';
import { ProductImagesApi } from './services/custom/ProductImages';
import { GpsPositionApi } from './services/custom/GpsPosition';
import { ModuleCategoryApi } from './services/custom/ModuleCategory';
import { ImageGalleryApi } from './services/custom/ImageGallery';
import { PartnerLerProductApi } from './services/custom/PartnerLerProduct';
import { ConfigParameterApi } from './services/custom/ConfigParameter';
import { ResiduePartnerKPIApi } from './services/custom/ResiduePartnerKPI';
import { ResiduePartnerKpiTypeApi } from './services/custom/ResiduePartnerKpiType';
import { StockProductionLotApi } from './services/custom/StockProductionLot';
import { StockQuantApi } from './services/custom/StockQuant';
import { AutologinApi } from './services/custom/Autologin';
import { LerOperatorTypeApi } from './services/custom/LerOperatorType';
import { LerOperationTypeApi } from './services/custom/LerOperationType';
import { FilterSizeAnalysisApi } from './services/custom/FilterSizeAnalysis';
import { FilterValuesQualityAnalysisApi } from './services/custom/FilterValuesQualityAnalysis';
import { HomogenizationOrderApi } from './services/custom/HomogenizationOrder';
import { HomogenizationOrderInLineApi } from './services/custom/HomogenizationOrderInLine';
import { HomogenizationOrderLineApi } from './services/custom/HomogenizationOrderLine';
import { HomogenizationOrderOutLineApi } from './services/custom/HomogenizationOrderOutLine';
import { LotConfigurationMpoLineApi } from './services/custom/LotConfigurationMpoLine';
import { LotQualityAnalysisApi } from './services/custom/LotQualityAnalysis';
import { LotQualityAnalysisImageApi } from './services/custom/LotQualityAnalysisImage';
import { ManufacturingProductionOrderApi } from './services/custom/ManufacturingProductionOrder';
import { ManufacturingProductionOrderLineApi } from './services/custom/ManufacturingProductionOrderLine';
import { ManufacturingWorkLineApi } from './services/custom/ManufacturingWorkLine';
import { ManufacturingWorkShiftApi } from './services/custom/ManufacturingWorkShift';
import { ProductionOrderApi } from './services/custom/ProductionOrder';
import { ProductionOrderInLineApi } from './services/custom/ProductionOrderInLine';
import { ProductionOrderLineApi } from './services/custom/ProductionOrderLine';
import { ProductionOrderOutLineApi } from './services/custom/ProductionOrderOutLine';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        SDKModels,
        OpenErpServiceApi,
        OpenErpUserApi,
        RoleApi,
        PartnerApi,
        PartnerAddressApi,
        PartnerContactApi,
        ProductApi,
        ProductCategoryApi,
        ProductCategoryTypeApi,
        ProductUomApi,
        ProductUomCategoryApi,
        PurchaseOrderApi,
        PurchaseOrderLineApi,
        PurchaseRequisitionApi,
        PurchaseRequisitionLineApi,
        CrmClaimApi,
        CrmCaseStageApi,
        CompanyApi,
        StockPickingApi,
        StockQuantPackageApi,
        MoveQualityControlApi,
        QualityMeasureValueApi,
        QualityMeasureApi,
        StockMoveApi,
        StockPickingLineApi,
        StockLocationApi,
        StockWarehouseLocationApi,
        StockWarehouseApi,
        DeliveryCarrierApi,
        ClaimLineApi,
        UsersApi,
        GroupsApi,
        ProductImagesApi,
        GpsPositionApi,
        ModuleCategoryApi,
        ImageGalleryApi,
        PartnerLerProductApi,
        ConfigParameterApi,
        ResiduePartnerKPIApi,
        ResiduePartnerKpiTypeApi,
        StockProductionLotApi,
        StockQuantApi,
        AutologinApi,
        LerOperatorTypeApi,
        LerOperationTypeApi,
        FilterSizeAnalysisApi,
        FilterValuesQualityAnalysisApi,
        HomogenizationOrderApi,
        HomogenizationOrderInLineApi,
        HomogenizationOrderLineApi,
        HomogenizationOrderOutLineApi,
        LotConfigurationMpoLineApi,
        LotQualityAnalysisApi,
        LotQualityAnalysisImageApi,
        ManufacturingProductionOrderApi,
        ManufacturingProductionOrderLineApi,
        ManufacturingWorkLineApi,
        ManufacturingWorkShiftApi,
        ProductionOrderApi,
        ProductionOrderInLineApi,
        ProductionOrderLineApi,
        ProductionOrderOutLineApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';




// WEBPACK FOOTER //
// ./src/sdk/index.ts